{
  "analogClock": {
    "centerCircleColor": "Center circle color",
    "centerCircleRadius": "Center circle radius",
    "clockRadius": "Clock radius",
    "clockShape": "Clock shape",
    "clockSize": "Clock size",
    "enableHourNumbers": "Enable hour numbers",
    "enableMinuteMarkers": "Enable minute markers",
    "hourNumbersType": "Hour numbers type",
    "hoursColor": "Hours color",
    "hoursNumbersColor": "Hours numbers color",
    "minuteMarkersColor": "Minute markers color",
    "minutesColor": "Minutes color",
    "secondsColor": "Seconds color",
    "squareRadius": "Square radius"
  },
  "arrow": {
    "headColor": "Head color",
    "pointerLength": "Pointer length",
    "pointerWidth": "Pointer width",
    "pointX1": "PointX1",
    "pointX2": "PointX2",
    "pointY1": "PointY1",
    "pointY2": "PointY2"
  },
  "audioVisualizer": {
    "barHeightMultiplier": "Bar height multiplier",
    "barsNumber": "Bars #",
    "bottomShapeColor": "Bottom shape color",
    "bottomShapeHeight": "Bottom shape height",
    "centerCircleRadius": "Center circle radius",
    "centerShape": "Center shape",
    "centerShapeColor": "Center shape color",
    "circleRadius": "Circle radius",
    "emissionRateNumber": "Emission rate number",
    "gap": "Gap",
    "imageWidth": "Image width",
    "lineWidth": "Line width",
    "maxParticlesNumber": "Max particles number",
    "minCircleSize": "Min circle size",
    "rangeCircleSize": "Range circle size",
    "shape": "Shape",
    "shapeColor": "Shape color",
    "shapeRadius": "Shape radius",
    "shapeScale": "Shape scale",
    "shapeSize": "Shape size",
    "shapeType": "Shape type",
    "upload": "Upload",
    "uploadNewImage": "Upload new image",
    "waveAmplitude": "Wave amplitude",
    "waveFrequency": "Wave frequency"
  },
  "circle": {
    "circleRadius": "Circle radius"
  },
  "container": {
    "desktopRequiredTitle": "Desktop required",
    "emptyState": "No overlays added yet",
    "selectToEdit": "Select an overlay to edit its properties"
  },
  "countDown": {
    "dateTime": "Date / time",
    "format": "Format",
    "hideWhenFinished": "Hide when countdown finished",
    "options": "Options",
    "style": "Style"
  },
  "customRectangle": {
    "bottomLeftRadius": "Bottom left radius",
    "bottomRightRadius": "Bottom right radius",
    "topLeftRadius": "Top left radius",
    "topRightRadius": "Top right radius"
  },
  "digitalClock": {
    "date": "Date",
    "dateColor": "Date color",
    "dateSize": "Date size",
    "enableDate": "Enable date",
    "format": "Format",
    "showDay": "Show day"
  },
  "donorsChatters": {
    "abbreviatedValue": "Abbreviated value",
    "listPaddingX": "List padding X",
    "listPaddingY": "List padding Y",
    "listRadius": "List radius",
    "listType": "List type",
    "maxRows": "Max rows",
    "rowsText": "Rows text",
    "showTheValue": "Show the value"
  },
  "ellipse": {
    "radiusX": "RadiusX",
    "radiusY": "RadiusY"
  },
  "marquee": {
    "behavior": "Behavior",
    "container": "Container",
    "stroke": "Stroke",
    "strokeOpacity": "Stroke opacity",
    "textPosition": "Text position"
  },
  "media": {
    "left": "Left",
    "top": "Top",
    "upload": "Upload"
  },
  "menu": {
    "customElementsGroup": "Custom elements",
    "mediaGroup": "Media",
    "shapesGroup": "Shapes",
    "textGroup": "Text"
  },
  "overlayTypes": {
    "analogClock": "Analog clock",
    "arrow": "Arrow",
    "audioVisualizer": "Audio visualizer",
    "circle": "Circle",
    "countDown": "Countdown",
    "customRectangle": "Custom rectangle",
    "digitalClock": "Digital clock",
    "donorsChattersList": "Donors & chatters list",
    "ellipse": "Ellipse",
    "gif": "GIF",
    "image": "Image",
    "marqueeText": "Marquee text",
    "progress": "Progress",
    "rectangle": "Rectangle",
    "ring": "Ring",
    "slidingText": "Sliding text",
    "songAlbumMetadata": "Song album (file metadata)",
    "songAuthor": "Song author",
    "songAuthorMetadata": "Song author (file metadata)",
    "songTitle": "Song title",
    "songTitleMetadata": "Song title (file metadata)",
    "text": "Text",
    "triangle": "Triangle",
    "video": "Video",
    "webSource": "Web source"
  },
  "progress": {
    "abbreviated": "Abbreviated",
    "barColor": "Bar color",
    "barHeight": "Bar height",
    "barOpacity": "Bar opacity",
    "barRadius": "Bar radius",
    "barSettings": "Bar settings",
    "barWidth": "Bar width",
    "centerText": "Center text",
    "channelLink": "Channel link",
    "circleRadius": "Circle radius",
    "circleSettings": "Circle settings",
    "circleThickness": "Circle thickness",
    "endText": "End text",
    "gapX": "GapX",
    "gapY": "GapY",
    "linkPlaceholder": "link...",
    "liveStreamLink": "Live stream link",
    "middleText": "Middle text",
    "platform": "Platform",
    "progressColor": "Progress color",
    "progressOpacity": "Progress opacity",
    "progressRadius": "Progress radius",
    "progressType": "Progress type",
    "shape": "Shape",
    "startText": "Start text",
    "targetType": "Target type",
    "type": "Type",
    "startTextColor": "Start text color",
    "endTextColor": "End text color",
    "middleTextColor": "Middle text color",
    "centerTextColor": "Center text color"
  },
  "ring": {
    "innerRadius": "Inner radius",
    "outerRadius": "Outer radius"
  },
  "shared": {
    "addColorStop": "Add color stop",
    "backgroundColor": "Background color",
    "blur": "Blur",
    "bold": "Bold",
    "borderRadius": "Border radius",
    "cancel": "Cancel",
    "color": "Color",
    "deleteOverlay": "Delete overlay",
    "deleteOverlayConfirmBody": "This overlay ({{type}}) is deleted from the stream. You can't undo this.",
    "deleteOverlayConfirmTitle": "Delete overlay",
    "direction": "Direction",
    "duration": "Duration",
    "enabled": "Enabled",
    "enableShadow": "Enable shadow",
    "enableStroke": "Enable stroke",
    "fillColor": "Fill color",
    "fontSize": "Font size",
    "gradientDirection": "Gradient direction",
    "height": "Height",
    "italic": "Italic",
    "lineThrough": "Line through",
    "moveToBack": "Move to back",
    "moveToFront": "Move to front",
    "offsetX": "OffsetX",
    "offsetY": "OffsetY",
    "opacity": "Opacity",
    "removeColorStop": "Remove color stop",
    "selectTimeZone": "Select a time zone",
    "shadow": "Shadow",
    "shadowBlur": "Shadow blur",
    "shadowColor": "Shadow color",
    "shadowOffsetX": "Shadow offset X",
    "shadowOffsetY": "Shadow offset Y",
    "shadowOpacity": "Shadow opacity",
    "strokeColor": "Stroke color",
    "strokeWidth": "Stroke width",
    "text": "Text",
    "textColor": "Text color",
    "timeZone": "Time zone",
    "underline": "Underline",
    "width": "Width",
    "transparent": "Transparent",
    "customColor": "Custom",
    "backToOverlays": "Back to overlays",
    "noColor": "None"
  },
  "text": {
    "centralizedText": "Centralized text",
    "colorN": "Color #{{n}}",
    "fillType": "Fill type",
    "letterSpacing": "Letter spacing",
    "stopN": "Stop #{{n}}",
    "stroke": "Stroke",
    "strokeType": "Stroke type",
    "textContent": "Text content"
  },
  "triangle": {
    "size": "Size"
  },
  "webSource": {
    "link": "Link"
  }
}
